import { render, staticRenderFns } from "./ProposalNetworksView.vue?vue&type=template&id=0770cbd1&scoped=true&"
import script from "./ProposalNetworksView.vue?vue&type=script&lang=js&"
export * from "./ProposalNetworksView.vue?vue&type=script&lang=js&"
import style0 from "./ProposalNetworksView.vue?vue&type=style&index=0&id=0770cbd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770cbd1",
  null
  
)

export default component.exports